/**
 * 活动所有的请求都放到这里，不准把ajax调用写到view或者别的模块
 */
import { get, post, getScript } from 'mihoyo-event-model';

export default {
  /**
   * 获取用户信息
   * @param options
   * @returns {*}
   */
  init: function(options = {}) {
    return get('/index', options);
  },

  /**
   * 获取用户列表
   * @returns {*}
   */
  getRepList: function(options = {}) {
    return get('/replyList', options);
  },

  reply: function(options = {}) {
    return post('/reply', options);
  },

  getCookieToken: function(options = {}) {
    return get(process.env.NODE_ENV === 'production'
      ? `https://webapi.account.mihoyo.com/Api/cookie_accountinfo_by_loginticket`
      : `https://test.account.mihoyo.com/Api/cookie_accountinfo_by_loginticket`, options);
  },

  /**
   * 新增用户
   * @param options
   * @returns {*}
   */
  addUser: function(options){

    var formatParams = function (params) {
      // 这里写格式化参数的逻辑
      params.sex = '男';
      params.nickname = '舰长大大';

      return params;
    }

    return post('user/add', options, formatParams);
  },

  getLocation: function () {
    return getScript('http://webstatic.mihoyo.com/mihoyo/common/location.min.js')
  }
}
